module.exports = __webpack_public_path__ + "static/img/game1_container.03717659.png";